import ApiService from '../../../core/services/ApiService';

export interface StandardCalculation {
  id: number;
  code: string;
  name: string;
  description: string;
  periodType: string;    // 'Operational' | 'Event'
  category: string;
  dependencies: string;  // comma-separated SC codes, e.g. "SC-001,SC-002"
  isActive: boolean;
  sortOrder: number;
}

export interface CreateStandardCalculationPayload {
  code: string;
  name: string;
  description: string;
  periodType: string;
  category: string;
  dependencies: string;
  sortOrder: number;
}

class StandardCalcService extends ApiService {
  getAll(): Promise<StandardCalculation[]> {
    return this.makeRequest<StandardCalculation[]>(
      '/api/standard-calculations',
      { extractData: true },
    );
  }

  create(payload: CreateStandardCalculationPayload): Promise<StandardCalculation> {
    return this.makeRequest<StandardCalculation>(
      '/api/standard-calculations',
      { method: 'POST', data: payload, extractData: true },
    );
  }
}

export const standardCalcService = new StandardCalcService();
